'use strict';

function ArrowNavDirective() {
  return {
    restrict: 'A',
    link: function(scope, elem) {
      elem.attr('tabindex', '1');
      elem.addClass('focusable');
      elem.on('keydown', function(e) {
        if (e.keyCode === 38) { // up
          $(elem[0]).prev('.focusable').focus();
          e.preventDefault();
        }

        else if (e.keyCode === 40) { // down
          $(elem[0]).next('.focusable').focus();
          e.preventDefault();
        }

        else if (e.keyCode === 13) { // enter
          elem.triggerHandler('click');
        }
      });
    }
  };
}

angular.module('dokiv')
  .directive('arrowNav', ArrowNavDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/ArrowNavDirective.js
// module id = 236
// module chunks = 0